module.exports = __webpack_public_path__ + "img/powered-by-syrenis-white.6fe56231.svg";